import { render, staticRenderFns } from "./ThreeBackground.vue?vue&type=template&id=a4e99f8e&scoped=true"
import script from "./ThreeBackground.vue?vue&type=script&lang=js"
export * from "./ThreeBackground.vue?vue&type=script&lang=js"
import style0 from "./ThreeBackground.vue?vue&type=style&index=0&id=a4e99f8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e99f8e",
  null
  
)

export default component.exports